import React from 'react';
import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';

const IntroDiv = styled.div`
  color: black;
  padding-top: ${props => (props.padding || 50)}px;
  padding-bottom: ${props => (props.padding || 50)}px;
  margin: 20px;
  text-align: center;
  line-height: 1.6em;
  font-size: 22px;
  font-family: 'Nunito Sans',arial;
  @media(max-width: 1200px) { font-size: 18px; }
  @media(max-width: 1024px) { font-size: 16px; }
  @media(max-width: 860px) { font-size: 14px; }
  @media(max-width: 480px) { font-size: 12px; padding-top: 0px; padding-bottom: 0px; }

`;
export const Intro = ({ title, padding }) => (
  <IntroDiv className="intro" padding={padding}>
    {typeof title === 'object' ? title.map(t => <div key={t}>{t}</div>) : title}
  </IntroDiv>
);

const SmallIntroDiv = styled.div`
  color: black;
  padding-top: ${props => (props.padding || 50)}px;
  padding-bottom: ${props => (props.padding || 50)}px;
  margin: 20px auto;
  max-width: 80%;
  text-align: center;
  line-height: 1.6em;
  font-size: 16px;
  font-family: 'Nunito Sans',arial;
  @media(max-width: 1200px) { font-size: 18px; }
  @media(max-width: 1024px) { font-size: 16px; }
  @media(max-width: 860px) { font-size: 14px; }
  @media(max-width: 480px) { font-size: 12px; padding-top: 0px; padding-bottom: 0px; }

`;
export const SmallIntro = ({ title, padding }) => (
  <SmallIntroDiv padding={padding}>
    {typeof title === 'object' ? title.map(t => <div key={t}><Markdown>{t}</Markdown></div>) : title}
  </SmallIntroDiv>
);



// WEBPACK FOOTER //
// ./src/components/Calculators/Intro.js